<h1>Gift Cards</h1>
<img class="img-responsive" src="assets/images/banners/banner_giftcard.jpg" />
<p>
  Looking for a great gift? Not sure what plant or landscape product to buy? Come in and get a gift
  card! We offer gift cards of any amount! You can order a gift card over the phone as well:
  <a href="tel:716-689-6764" (click)="analyticsService.logEvent('call_giftcard')">
    716-689-6764.
  </a>
</p>

<ng-container *ngIf="shopSettings$ | async as shopSettings">
  <div class="row" *ngIf="shopSettings.isGiftCardPurchasingEnabled">
    <div class="col-md-12">
      <h2>Order Online</h2>

      <p class="h5">Select an amount to purchase:</p>
      <a [href]="item.paymentLink" *ngFor="let item of giftcardOptions" target="_blank">
        <button class="gc-btn" nbButton size="giant" status="primary" shape="round">
          {{ item.amount }}
        </button>
      </a>

      <p>Gift cards are delivered via email.</p>
    </div>
    <div class="col-sm-6 col-xs-12">
      <nb-alert status="warning"
        >Please review the below from New York State.
        <a
          href="https://dos.ny.gov/news/new-york-department-state-reminds-businesses-new-law-protect-consumers-potential-gift-card"
          target="_blank"
        >
          Learn More Here
        </a>
      </nb-alert>
      <img class="img-responsive" src="assets/images/giftcard-warning.png" />
    </div>
  </div>
</ng-container>
